import React from 'react';
import '../../../Assets/Sidebar.css';
import { Layout, Menu } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { faUserGroup } from '@fortawesome/free-solid-svg-icons';
import { HomeOutlined, SettingOutlined } from '@ant-design/icons';
import {ReactComponent as VerifyIcon} from "../../../Assets/images/icon/Verifiy-tick-icon.svg"
import {ReactComponent as ReportIcon } from "../../../Assets/images/icon/Reports icon.svg"
import {ReactComponent as PostManageIcon } from "../../../Assets/images/icon/Post Management.svg"
import { ReactComponent as CategoryIcon } from "../../../Assets/images/icon/Category.svg";
import { useNavigate, useLocation } from 'react-router-dom';
const { Sider } = Layout;

const Sidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleMenuClick = (e) => {
        navigate(e.key);
    };

    return (
        <Sider width={250} className='Sidebar-styles'>
            <Menu
                theme="dark"
                mode="inline"
                selectedKeys={[location.pathname]}  // Set the active link based on current location
                onClick={handleMenuClick}
            >
                <Menu.Item key="/dashboard" icon={<HomeOutlined />}>
                    Dashboard
                </Menu.Item>
                <Menu.Item key="/user-details" icon={<FontAwesomeIcon icon={faUsers} />}>
                    User Management
                </Menu.Item>
                <Menu.Item key="/roles" icon={<SettingOutlined />}>
                    Roles
                </Menu.Item>
                <Menu.Item key="/waiting-list" icon={<FontAwesomeIcon icon={faUserGroup} />}>
                    Waiting List
                </Menu.Item>
                <Menu.Item key="/verification-list" icon={<VerifyIcon style={{ width: "16px", height: "16px" }} />}>
                    Profile Verification
                </Menu.Item>
                <Menu.Item key="/post-management" icon={<PostManageIcon style={{ width: "16px", height: "16px" }} />}>
                    Post Management
                </Menu.Item>
                <Menu.Item key="/reports" icon={<ReportIcon style={{ width: "16px", height: "16px" }} />}>
                    Reports
                </Menu.Item>
                <Menu.Item key="/category" icon={<CategoryIcon style={{ width: "16px", height: "16px" }} />}>
                    Category
                </Menu.Item>
            </Menu>
        </Sider>
    );
};

export default Sidebar;
